angular.module('app')
    .controller('FaqCtrl', function () {

    });